import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Button from '../../Button';
import Field from '../Field';
import ErrorBlock from '../../common/ErrorBlock';

import { PROFILE, COMMON } from '../../../constants/strings';

import styles from '../index.styl';

const CONFIRM_BUTTON_WIDTH = 168;

class MobilePhoneConfirmation extends PureComponent {
  state = {
    code: '',
  };

  static childContextTypes = {
    intl: PropTypes.object,
  };

  getChildContext = () => {
    return {
      intl: this.props.intl,
    };
  };

  render() {
    const {
      phone,
      onConfirm,
      onCancel,
      error,
      intl: { formatMessage },
    } = this.props;
    const field = {
      name: formatMessage(PROFILE.edit.confirmCode),
      value: '',
      fieldName: 'confirmationCode',
      maxLength: 20,
    };
    const fieldDescriptor = Object.assign({}, field, {
      value: this.state.code,
    });

    return (
      <section styleName="mobile-phone-confirmation">
        <section>
          {formatMessage(PROFILE.edit.phoneConfirmationText, { phone })}
        </section>
        <section styleName="phone-confirmation-flex-wrapper">
          <section>
            <Field
              children={fieldDescriptor}
              fieldStyle={{ padding: 0 }}
              onChange={code => this.setState({ code })}
              editMode
            />
          </section>
          <If condition={error}>
            <ErrorBlock
              className="mt3"
              errors={formatMessage(PROFILE.edit.invalidCode)}
            />
          </If>
          <section className="mt3">
            <Button
              className="mr2"
              children={formatMessage(PROFILE.edit.confirmCode)}
              style={{ width: CONFIRM_BUTTON_WIDTH }}
              raised
              color="primary"
              onClick={() => onConfirm(this.state.code)}
            />
            <Button
              children={formatMessage(COMMON.cancel)}
              raised
              color="accent"
              onClick={onCancel}
            />
          </section>
        </section>
      </section>
    );
  }
}

MobilePhoneConfirmation.propTypes = {
  phone: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  error: PropTypes.any,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default CSSModules(MobilePhoneConfirmation, styles);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/MobilePhoneConfirmation/index.jsx